module.exports = function() {
  return new Worker(__webpack_public_path__ + "35ca8f4374022fd85809.worker.js");
};